import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

const About = () => {
  const chartRef = useRef(null);

  useEffect(() => {
    const chart = echarts.init(chartRef.current);
    chart.setOption({
      animation: false,
      radar: {
        indicator: [
          { name: '클라우드', max: 120 },
          { name: '리눅스(우분투)', max: 130 },
          { name: '쿠버네티스', max: 110 },
          { name: 'CI/CD', max: 120 },
          { name: '기타', max: 100 }
        ]
      },
      series: [{
        type: 'radar',
        data: [{
          value: [95, 90, 85, 88, 92],
          name: '교육 역량',
          areaStyle: { color: 'rgba(59, 130, 246, 0.2)' },
          lineStyle: { color: '#3B82F6' }
        }]
      }]
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-6">About Us</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
            <div>
              <h3 className="text-2xl font-bold mb-6">우리의 비전</h3>
              <ul className="space-y-4">
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>실무에 적용 가능한 교육</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>시스템 엔지니어를 위한 관리 도구 제작</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>-</span>
                </li>
              </ul>
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-6">핵심 가치</h3>
              <ul className="space-y-4">
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>가성비</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>효율</span>
                </li>
                <li className="flex items-center">
                  <i className="fas fa-check text-[#3B82F6] mr-3"></i><span>-</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="mb-20">
            <h3 className="text-2xl font-bold mb-8 text-center">교육 역량</h3>
            <div ref={chartRef} className="w-full h-[400px]"></div>
          </div>
          <div className="text-center">
            <h3 className="text-2xl font-bold mb-6">Contact Us</h3>
            <div className="space-y-4">
              <p><i className="fas fa-envelope mr-2"></i> icurfer@gmail.com</p>
              <p><i className="fas fa-phone mr-2"></i> - </p>
              <p><i className="fas fa-map-marker-alt mr-2"></i> - </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;